import styled from 'styled-components';
import CircleCloseIcon from '../../../../new-components/svg-icons/CircleCloseIcon';

interface CloseButtonProps {
  handleClick: () => void;
}
const CloseButton = ({ handleClick }: CloseButtonProps) => {
  return (
    <Container onClick={handleClick}>
      <CircleCloseIcon />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export default CloseButton;
